// removed by extract-text-webpack-plugin
module.exports = {"event-panel":"event-panel__event-panel__2UjuS","event-wrapper":"event-panel__event-wrapper__3j79L","download-container":"event-panel__download-container__1FhZ-","download-wrapper":"event-panel__download-wrapper__1mwk1","text":"event-panel__text__3-ZV2","button-inner":"event-panel__button-inner__3dZ_b","close-text":"event-panel__close-text__3FKLA"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/event/EventList/EventPanel/event-panel.scss
// module id = 1739
// module chunks = 1